let appFunction = {};
import Util from "./util";

appFunction.login = function () {
  if (typeof window.IARTSCHOOL != "undefined") {
    window.IARTSCHOOL.login();
  } else if (typeof window.android != "undefined") {
    window.android.loginOut();
  }
};
appFunction.share = function (obj) {
  // var obj = {
  //     title: this.info.sharetitle,  //标题
  //     imgUrl: this.info.shareicon,   //封面
  //     url: url,  //url,
  //     content: this.info.signature ? this.info.signature : "",  //描述
  //     type: -1,   //-1 不指定平台   0 微信好友 1朋友圈
  //     id: this.packageid, //可无
  //   };
  if (typeof window.IARTSCHOOL != "undefined") {
    window.IARTSCHOOL.share(obj);
  } else if (typeof window.android != "undefined") {
    window.android.share(JSON.stringify(obj));
  }
};
appFunction.delayShare = function (obj) {
  //  同share
  if (typeof window.IARTSCHOOL != "undefined") {
    window.IARTSCHOOL.delayShare(obj);
  } else if (typeof window.android != "undefined") {
    window.android.delayShare(JSON.stringify(obj));
  }
};
appFunction.courseDetail = function (obj) {
  if (typeof window.android != "undefined") {
    window.android.toCourseDetails(JSON.stringify(obj)); //{ courseid: item.referencevalue }
  } else if (typeof window.IARTSCHOOL != "undefined") {
    window.IARTSCHOOL.toCourseDetails(obj); //{ courseid: item.referencevalue }
  }
};
appFunction.toSeckillDetails = function (obj) {
  //秒杀课程
  if (typeof window.android != "undefined") {
    window.android.toSeckillDetails(JSON.stringify(obj)); //{ flashsaleskuid: flashsaleskuid }
  } else if (typeof window.IARTSCHOOL != "undefined") {
    window.IARTSCHOOL.toSeckillDetails(obj); //{ flashsaleskuid:flashsaleskuid }
  }
};
appFunction.toGroupDetails = function (obj) {
  //团购课程
  if (typeof window.android != "undefined") {
    window.android.toGroupDetails(JSON.stringify(obj)); //{ promotiongroupdkuid: promotiongroupdkuid }
  } else if (typeof window.IARTSCHOOL != "undefined") {
    console.log(window.IARTSCHOOL);
    window.IARTSCHOOL.toGroupDetails(obj); //{ promotiongroupdkuid: promotiongroupdkuid }
  }
};
appFunction.toPackageDetail = function (obj) {
  //套餐详情
  if (typeof window.android != "undefined") {
    if (!window.android.packageCourse) {
      return Util.toast({ msg: "该版本暂不支持该功能，请更新app版本" });
    }
    window.android.packageCourse(
      JSON.stringify(obj) //{ packageid: this.info.packageid }
    );
  } else if (typeof window.IARTSCHOOL != "undefined") {
    window.IARTSCHOOL.packageCourse(obj); //{packageid: this.info.packageid,}
  }
};
appFunction.toBuyCoursePackage = function (obj) {
  //套餐支付
  if (typeof window.android != "undefined") {
    //String packageId,String sellingPrice,String productId
    window.android.toBuyCoursePackage(
      JSON.stringify(obj) //{ packageid: this.info.packageid }
    );
  } else if (typeof window.IARTSCHOOL != "undefined") {
    window.IARTSCHOOL.toBuyCoursePackage(obj); //{packageid: this.info.packageid,}
  }
};
appFunction.back = function () {
  if (typeof window.IARTSCHOOL != "undefined") {
    window.IARTSCHOOL.backToHome();
  } else if (typeof window.android != "undefined") {
    window.android.exitPage();
  }
};
appFunction.buyVip = function (obj) {
  if (typeof window.android != "undefined") {
    //         certificatetype 1034 小类卡 小类卡额外参数
    //         parentidruleid    中类卡的certificaruleid 小类卡额外参数
    //         referencevalue    certificatemasterid
    window.android.toBuyVip(JSON.stringify(obj)); //{ referencevalue: item.businessid }
  } else if (typeof window.IARTSCHOOL != "undefined") {
    //         certificatetype 1034 小类卡 小类卡额外参数
    //         parentidruleid    中类卡的certificaruleid 小类卡额外参数
    //         referencevalue    certificatemasterid
    window.IARTSCHOOL.toBuyVip(obj); //{ referencevalue: item.businessid}
  }
};
appFunction.saveImg = function (url) {
  if (typeof window.android != "undefined") {
    window.android.savePicture(JSON.stringify({ imgSource: url }));
  } else if (typeof window.IARTSCHOOL != "undefined") {
    window.IARTSCHOOL.saveImg({ base64: url });
  }
};
//跳转名师阅卷列表页
appFunction.toTeachMarkingList = function () {
  if (typeof window.android != "undefined") {
    window.android.toTeachMarkingList();
  } else if (typeof window.IARTSCHOOL != "undefined") {
    window.IARTSCHOOL.toTeachMarkingList({});
  }
};

//ios获取token
window.getIosResult = function (result) {
  // 处理原生返回的结果
  if (result) {
    result = JSON.parse(result);
    if (result.token) {
      localStorage.setItem("authorization", result.token);
    }
    setTimeout(() => {
      sessionStorage.setItem("ua", "iartIos");
    }, 1200);
  }
  //   console.log("Received result from iOS:", result);
};

appFunction.getIosToken = function () {
  if (window.webkit&&window.webkit.messageHandlers&&window.webkit.messageHandlers.getNativeUserToken) {
    window.webkit.messageHandlers.getNativeUserToken.postMessage(null);
  }
};

//去提现
appFunction.toPromotionBonus = function () {
  if (typeof window.android != "undefined") {
    window.android.toPromotionBonus();
  } else if (typeof window.IARTSCHOOL != "undefined") {
    window.IARTSCHOOL.toPromotionBonus({});
  }
};
export default appFunction;
